import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { colorStyles } from './styles';
const sliderTrackStyles = css `
  ${styleUtils.transition('padding')}
  height: ${styleUtils.rem(2)};
  position: absolute;
  width: 100%;
`;
const sliderTrackBackgroundStyles = css `
  background-color: ${theme.colors.gray400};
  height: 100%;
  width: 100%;
`;
const sliderTrackFilledStyles = css `
  height: 100%;
`;
const SliderTrack = ({ color, hasIndicatorCssAnimation, relativeWidth, }) => (_jsx("div", Object.assign({ css: sliderTrackStyles }, { children: _jsx("div", Object.assign({ css: sliderTrackBackgroundStyles }, { children: _jsx("div", { css: css `
          ${sliderTrackFilledStyles}
          ${colorStyles[color]}
          ${hasIndicatorCssAnimation && styleUtils.transition('width')}
          width: ${relativeWidth * 100}%;
          will-change: transition, width;
        ` }) })) })));
const MemoizedSliderTrack = memo(SliderTrack);
export { MemoizedSliderTrack as SliderTrack };
// MC-1068 Temporary hack for Storybook.
export default MemoizedSliderTrack;
